import { defineCustomElement } from "vue";
import BBPickupPointSelector from "./components/pickup-point-selector.vue";
import type { TPickupPoint } from "./types";

export const BBPickupPointSelectorElement = defineCustomElement(BBPickupPointSelector, {
  shadowRoot: false,
});

customElements.define("bb-pickup-point-selector", BBPickupPointSelectorElement);

// Export shared types
export type { TPickupPoint } from "./types";

declare module "vue" {
  interface GlobalComponents {
    // Be sure to pass in the Vue component type here
    // (SomeComponent, *not* SomeElement).
    // Custom Elements require a hyphen in their name,
    // so use the hyphenated element name here.
    "bb-pickup-point-selector": typeof BBPickupPointSelector;
  }
}

// Extend the custom element to include our callback property
declare global {
  namespace JSX {
    interface IntrinsicElements {
      "bb-pickup-point-selector": {
        "delivery-type-id"?: number;
        "onPickupPointConfirmed"?: (pickupPoint: TPickupPoint) => void;
      };
    }
  }
}
